import bufferedRowService from '@grouper/modules/database/services/view/bufferedRows'

export default (client) => bufferedRowService(client, 'timeline')
